import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {

  private loadingSubject = new BehaviorSubject<string | null>(null);
  loading$ = this.loadingSubject.asObservable();

  show(message: string) {
    this.loadingSubject.next(message);
  }

  hide() {
    this.loadingSubject.next(null);
  }
}
